import styled from 'styled-components';

const Wrapper = styled.div`
    max-width: 440px;
    min-height: 100px;
    padding-block: 20px;
    @media only screen and (max-width: 1024px) {
        padding: 20px;
    }
`;

export default Wrapper;